__turbopack_context__.v({
  "left-content": "SplitSection-module-scss-module__kORvAa__left-content",
  "right-content": "SplitSection-module-scss-module__kORvAa__right-content",
  "section": "SplitSection-module-scss-module__kORvAa__section",
});
